import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useTreatmentTranslations = () => {
  const { i18n } = useTranslation();
  const [treatmentTranslations, setTreatmentTranslations] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTreatmentTranslations = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/locales/${i18n.language}/treatments.json`);
        
        if (!response.ok) {
          // Fallback to English if the language file doesn't exist
          const fallbackResponse = await fetch('/locales/en/treatments.json');
          const fallbackData = await fallbackResponse.json();
          setTreatmentTranslations(fallbackData);
        } else {
          const data = await response.json();
          setTreatmentTranslations(data);
        }
      } catch (error) {
        console.error('Error loading treatment translations:', error);
        // Fallback to null, components should handle this gracefully
        setTreatmentTranslations(null);
      } finally {
        setLoading(false);
      }
    };

    loadTreatmentTranslations();
  }, [i18n.language]);

  const getTranslatedTreatmentName = (treatmentId, fallbackName) => {
    if (!treatmentTranslations?.treatments?.[treatmentId]) {
      return fallbackName;
    }
    return treatmentTranslations.treatments[treatmentId].name || fallbackName;
  };

  const getTranslatedTreatmentDescription = (treatmentId, fallbackDescription) => {
    if (!treatmentTranslations?.treatments?.[treatmentId]) {
      return fallbackDescription;
    }
    return treatmentTranslations.treatments[treatmentId].description || fallbackDescription;
  };

  const getTranslatedCategory = (categoryKey, fallbackCategory) => {
    if (!treatmentTranslations?.categories?.[categoryKey]) {
      return fallbackCategory;
    }
    return treatmentTranslations.categories[categoryKey] || fallbackCategory;
  };

  return {
    treatmentTranslations,
    loading,
    getTranslatedTreatmentName,
    getTranslatedTreatmentDescription,
    getTranslatedCategory
  };
};
